import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class ProductWarranty extends Page{
    constructor(){
        super({
            id : 'product_warranty',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}